import { render, staticRenderFns } from "./redactor.vue?vue&type=template&id=44b277c6&"
import script from "./redactor.vue?vue&type=script&lang=js&"
export * from "./redactor.vue?vue&type=script&lang=js&"
import style0 from "./redactor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports